import React from 'react';
import AppIcon from '../ui/AppIcon';

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <div className="legal-page">
        <div className="legal-header">
          <AppIcon size={50} />
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>Information We Collect</h2>
            <p>
              At Nurturing Inner Love, we collect information to provide better services to our users. 
              This includes:
            </p>
            <ul>
              <li><strong>Account Information:</strong> Email address, password (encrypted), and profile preferences</li>
              <li><strong>Usage Data:</strong> Chapter progress, exercise completion, and learning analytics</li>
              <li><strong>Payment Information:</strong> Billing details processed securely through Stripe</li>
              <li><strong>Device Information:</strong> Device type, operating system, and app version for support purposes</li>
            </ul>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and maintain our mindfulness learning platform</li>
              <li>Process subscription payments and manage your account</li>
              <li>Track your learning progress and personalize your experience</li>
              <li>Send important updates about your account and subscription</li>
              <li>Improve our services based on usage patterns and feedback</li>
              <li>Provide customer support when you contact us</li>
            </ul>
          </section>

          <section>
            <h2>Information Sharing</h2>
            <p>
              We do not sell, trade, or otherwise transfer your personal information to third parties, 
              except in the following limited circumstances:
            </p>
            <ul>
              <li><strong>Service Providers:</strong> We share data with trusted partners like Firebase and Stripe to operate our service</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
              <li><strong>Business Transfers:</strong> In the event of a merger or acquisition (users will be notified)</li>
            </ul>
          </section>

          <section>
            <h2>Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information:
            </p>
            <ul>
              <li>All data is encrypted in transit and at rest</li>
              <li>We use Firebase's enterprise-grade security infrastructure</li>
              <li>Payment information is processed securely through Stripe (PCI DSS compliant)</li>
              <li>Regular security audits and updates to our systems</li>
            </ul>
          </section>

          <section>
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li><strong>Access:</strong> Request a copy of your personal data</li>
              <li><strong>Correction:</strong> Update or correct your information through your account settings</li>
              <li><strong>Deletion:</strong> Delete your account and associated data</li>
              <li><strong>Portability:</strong> Export your learning progress and data</li>
              <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
            </ul>
          </section>

          <section>
            <h2>Cookies and Tracking</h2>
            <p>
              We use essential cookies to maintain your login session and remember your preferences. 
              We do not use tracking cookies for advertising purposes.
            </p>
          </section>

          <section>
            <h2>Children's Privacy</h2>
            <p>
              Our service is intended for users aged 13 and older. We do not knowingly collect 
              personal information from children under 13.
            </p>
          </section>

          <section>
            <h2>Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify users of any 
              material changes via email or through our platform.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> privacy@nurturinginnerlove.com</p>
              <p><strong>Support:</strong> support@nurturinginnerlove.com</p>
              <p><strong>Website:</strong> <a href="https://nurturinginnerlove.com">nurturinginnerlove.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
